import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { Button } from 'common/components/Button'
import { CreateOrgInput } from 'common/components/CreateOrgInput'
import { useCreateOrg } from 'common/hooks/useCreateOrg'
import { forwardRef, useState } from 'react'
import { BooleanParam, useQueryParam } from 'use-query-params'

export const useCreateOrgDialog = () => {
  /**
   * Create a new org view is driven based on this query param being set
   */
  const [isOpen, setIsOpen] = useQueryParam('new-org', BooleanParam)
  const openDialog = () => setIsOpen(true)
  const closeDialog = () => setIsOpen(undefined)

  return { openDialog, closeDialog, isOpen }
}

export const CreateNewOrgDialog = forwardRef(
  ({ renderTrigger, onClick = {}, ...rest }, outerRef) => {
    const [orgName, setOrgName] = useState('')
    const { isOpen, closeDialog, openDialog } = useCreateOrgDialog()
    const { isCreating, isValidating, isValid, errorMsg, createOrg } = useCreateOrg({ orgName })

    return (
      <>
        {renderTrigger ? renderTrigger(openDialog) : null}
        <Dialog
          open={!!isOpen}
          onClose={closeDialog}
          onExited={() => {
            setOrgName('')
          }}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Create Org</DialogTitle>

          <DialogContent>
            <Box width="100%" pb={2}>
              <CreateOrgInput
                orgName={orgName}
                setOrgName={setOrgName}
                createOrg={createOrg}
                errorMsg={errorMsg}
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={closeDialog} color="secondary">
              Cancel
            </Button>

            <Button
              color="primary"
              variant="contained"
              loading={isCreating || isValidating}
              onClick={() => {
                createOrg()
              }}
              disabled={!isValid}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
)
